import React, { useState} from 'react';
import {useUnifyAdminStore} from '../AdminStore';
import * as StyledComponents from '../StyledComponents';
import get from 'lodash/get';
import { t } from 'i18next';

export const EnterpriseIncludePermissionField = (): JSX.Element => {
    const permissions = useUnifyAdminStore(state => state.permissions);
    const [isValidEnterpriseId, setIsValidEnterpriseId] = useState<Boolean>(true)
    /**
     * Data Store
     */
    const sideSheetData = useUnifyAdminStore((state) => state.sideSheetData);
    const updateSideSheetData = useUnifyAdminStore(
        (state) => state.updateSideSheetData
    );
    const enterprisesStr = get(sideSheetData, 'permissions.include_enterprise', ['']).join(',')
    
    const handleUpdatePermissionField = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        return updateSideSheetData({
            fieldName: event.target.name,
            value: event.target.value
        });
    };
    const handleFieldBlur = (
        event: React.FocusEvent<HTMLInputElement>
    ) => {
        const {value} = event.target;
        const isValid = /^E\d{6}(,E\d{6})*$/.test(value) || event.target.value === '';
        setIsValidEnterpriseId(isValid)
    };


    return (
        <StyledComponents.StyledPermissionContainer>
            <StyledComponents.StyledPermission
                dataTestId="permission-field-input"
                errorMessage={t('appsAndWorkflows.enterpriseIdError')}
                id="permission-field-input"
                inputDivider="left"
                label={t('appsAndWorkflows.include')}
                name="include_enterprise"
                onChange={handleUpdatePermissionField}
                onInputClear={function noRefCheck() {
                }}
                onBlur={handleFieldBlur}
                placeholder="Eg. E123221,E3422134"
                value={enterprisesStr}
                enableCustomValidation
                hasError={!isValidEnterpriseId}
                isDisabled={permissions?.hasAppReadOnlyPermissions && !permissions?.hasAppSuperAdminPermissions && !permissions.hasAppUpdatePermissions}
                maxLength={80000}
            />
        </StyledComponents.StyledPermissionContainer>
    );
};
